import { render, staticRenderFns } from "./IssuesTable.vue?vue&type=template&id=495ff62e&lang=pug&"
import script from "./IssuesTable.vue?vue&type=script&lang=js&"
export * from "./IssuesTable.vue?vue&type=script&lang=js&"
import style0 from "./IssuesTable.vue?vue&type=style&index=0&id=495ff62e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports